/**
 * Shared email and send-eligibility logic for candidates.
 * Single source for validation and send rules — no duplication in components.
 */
import { Candidate } from '../models/job';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidEmail(value: string): boolean {
  if (!value || typeof value !== 'string') return false;
  return EMAIL_REGEX.test(value.trim());
}

export function isMissingEmail(candidate: Candidate): boolean {
  return !candidate?.hasValidEmail;
}

/**
 * Single source for "can this candidate be sent an interview?".
 * Used by row Send button, bulk selection, and dialogs.
 */
export function canSendInterview(
  candidate: Candidate,
  options: { requiresReview?: boolean } = {}
): boolean {
  if (!candidate) return false;
  if (options.requiresReview) return false;
  const canInvite =
    candidate.pipelineStageSemantic === 'pending' ||
    candidate.pipelineStageSemantic === 'shortlisted';
  return canInvite && candidate.hasValidEmail;
}

/**
 * Filter candidates that are eligible for sending (bulk send and selection).
 */
export function candidatesEligibleForSend(
  candidates: Candidate[],
  options: { requiresReview?: boolean } = {}
): Candidate[] {
  return candidates.filter((c) => canSendInterview(c, options));
}
